import React from 'react';

import Button, { LoadingButton } from '@atlaskit/button';
import Modal, {
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from '@atlaskit/modal-dialog';

import { ModalBody, ModalFooter } from '@qality/common-components';
import { messages } from '@qality/common-messages';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  testCycleName: string;
};

export default function DeleteTestCycleDialog({
  isOpen,
  onClose,
  onDelete,
  testCycleName,
}: Props): JSX.Element {
  const [deleting, setDeleting] = React.useState(false);

  const deleteTestCycle = async () => {
    setDeleting(true);
    await onDelete();
    setDeleting(false);
  };

  return (
    <ModalTransition>
      {isOpen && (
        <Modal
          onClose={onClose}
          shouldCloseOnOverlayClick={false}
          shouldCloseOnEscapePress={true}
          shouldScrollInViewport
        >
          <ModalHeader>
            <ModalTitle appearance='danger'>Delete Test Cycle</ModalTitle>
          </ModalHeader>
          <ModalBody>
            <div id='delete_test_cycle_dialog'>
              <p>
                Are you sure you want to delete{' '}
                <b style={{ wordBreak: 'break-word' }}>{testCycleName}</b>?
              </p>
              <p>{messages['info.deleteTestCycle.message']}</p>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button appearance='subtle' onClick={onClose}>
              Close
            </Button>
            <LoadingButton
              isLoading={deleting}
              appearance='danger'
              onClick={deleteTestCycle}
              autoFocus
            >
              Yes, delete
            </LoadingButton>
          </ModalFooter>
        </Modal>
      )}
    </ModalTransition>
  );
}
